import type { CSSProperties } from 'react';

export interface EnvBannerProps {
  /** Render nothing when false. Apps pass `APP_ENV !== 'prod'`. */
  show: boolean;
  /** Ribbon text. Defaults to `TEST ENVIRONMENT`. */
  label?: string;
}

/**
 * A fixed badge pinned to the top-right corner of the viewport, used to mark
 * non-production deployments (staging / local). Purely decorative — it never
 * intercepts clicks (`pointerEvents: none`) and sits above app chrome so it
 * stays visible on every screen. Hidden in production by passing `show={false}`.
 */
export function EnvBanner({ show, label = 'TEST ENVIRONMENT' }: EnvBannerProps) {
  if (!show) return null;

  const style: CSSProperties = {
    position: 'fixed',
    top: 12,
    right: 12,
    padding: '6px 12px',
    background: '#E07A3F',
    color: '#FFFFFF',
    fontFamily: 'var(--font-sans, system-ui, sans-serif)',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    borderRadius: 6,
    boxShadow: '0 2px 10px rgba(0,0,0,0.18)',
    pointerEvents: 'none',
    userSelect: 'none',
    zIndex: 2147483647,
  };

  return (
    <div role="status" aria-label={label} className="gc-env-banner" style={style}>
      {label}
    </div>
  );
}
